import React, { Component } from 'react';
import {
    estadoRecordatorio, recordarSaldo, YA_RECORDADO, pesos, fechaCorta, motivoNoEnvio, textoUltimoRecordatorio,
} from '../utils/storeCreditReminder';

// "Recordar saldo" de UN cliente, en la tarjeta de crédito de su detalle. Si ya se le recordó
// hace menos de 30 días pide confirmación (decisión del dueño); si no tiene un mail al que se le
// pueda escribir, lo dice y no ofrece el botón.
class RecordarSaldoButton extends Component {

    constructor(props) {
        super(props);
        this.state = { estado: null, error: null, enviando: false, aviso: null };
    }

    componentDidMount() {
        this.cargar();
    }

    cargar = async () => {
        try {
            this.setState({ estado: await estadoRecordatorio(this.props.cedula), error: null });
        } catch (e) {
            this.setState({ error: e.message });
        }
    }

    recordar = async () => {
        const { estado } = this.state;
        const { cedula, saldo } = this.props;
        const r = estado.recordatorio || {};
        let forzar = false;
        if (r.reciente && r.ultimoEnviado) {
            if (!window.confirm(`Ya le recordaste el saldo el ${fechaCorta(r.ultimoEnviado.fecha)}. ¿Mandarle otro recordatorio igual?`)) return;
            forzar = true;
        } else if (!window.confirm(`¿Mandarle a ${estado.email} el recordatorio de su saldo (${pesos(saldo)})?`)) {
            return;
        }
        this.setState({ enviando: true, aviso: null });
        try {
            const res = await recordarSaldo(cedula, forzar);
            this.mostrarResultado(res);
        } catch (e) {
            // Otra pestaña lo mandó entre que cargó la tarjeta y el clic: se pregunta de nuevo.
            if (e.code === YA_RECORDADO && window.confirm(`Ya le recordaste el saldo el ${fechaCorta(e.body && e.body.data)}. ¿Mandarle otro recordatorio igual?`)) {
                try {
                    this.mostrarResultado(await recordarSaldo(cedula, true));
                } catch (e2) {
                    this.setState({ enviando: false, aviso: { tipo: 'danger', texto: e2.message } });
                }
                return;
            }
            this.setState({ enviando: false, aviso: { tipo: 'danger', texto: e.code === YA_RECORDADO ? null : e.message } });
        }
    }

    mostrarResultado(res) {
        const ok = res.estado === 'enviado';
        const intento = { fecha: res.fecha, estado: ok ? 'SENT' : 'FAILED', mail: res.email };
        this.setState((s) => ({
            enviando: false,
            aviso: ok
                ? { tipo: 'success', texto: `Listo: le mandamos el recordatorio a ${res.email}.` }
                : { tipo: 'danger', texto: `No se pudo mandar el mail a ${res.email}. Probá de nuevo en un rato.` },
            estado: {
                ...s.estado,
                recordatorio: ok
                    ? { ultimo: intento, ultimoEnviado: intento, reciente: true }
                    : { ...(s.estado.recordatorio || {}), ultimo: intento },
            },
        }));
    }

    render() {
        const { estado, error, enviando, aviso } = this.state;
        if (error) return <small className="text-muted">No se pudo consultar el último recordatorio.</small>;
        if (!estado) return null;
        const motivo = motivoNoEnvio(estado.mail);
        return (
            <div className="text-right">
                {motivo
                    ? <span className="badge badge-warning">{motivo} · no se le puede recordar el saldo</span>
                    : (
                        <button type="button" className="btn btn-white" disabled={enviando} onClick={this.recordar}>
                            {enviando ? 'Enviando…' : 'Recordar saldo'}
                        </button>
                    )}
                <div><small className="text-muted">Último recordatorio: {textoUltimoRecordatorio(estado.recordatorio)}</small></div>
                {aviso && aviso.texto && <div><small className={`text-${aviso.tipo}`}>{aviso.texto}</small></div>}
            </div>
        );
    }
}

export default RecordarSaldoButton;
